import React, { useMemo } from "react";
import { connect } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import { ProviderLogo } from "./ProviderLogo";
import { parseProviderKey, getSortedAllowedProviderKeys } from "./FilterSearch";

// Provider filtreleme + sıralama mantığı burada KOPYALANMIYOR - Casino/FilterSearch.jsx'teki
// tek doğruluk kaynağı (getSortedAllowedProviderKeys) kullanılıyor. Böylece nonameHero desteği,
// öncelik sırası ve NONAMEHERO_/GASEA_ önek düzeltmesi gibi değişiklikler tek yerden yönetilir.
const ProviderSwipeSelector = (props) => {
  const {
    games,
    permissions,
    loggedIn,
    selectedProviders,
    setSelectedProviders,
    setProvider,
  } = props;

  const providerKeys = useMemo(
    () => getSortedAllowedProviderKeys(games, permissions, loggedIn),
    [games, permissions, loggedIn],
  );

  const parseOriginalName = (key) => parseProviderKey(key).originalName;

  const handleToggle = (providerKey) => {
    if (!setSelectedProviders) return;
    const current = Array.isArray(selectedProviders) ? selectedProviders : [];
    const isAlreadySelected =
      current.length === 1 && current[0] === providerKey;
    setSelectedProviders(isAlreadySelected ? [] : [providerKey]);
  };

  const handleClearAll = () => {
    if (setSelectedProviders) setSelectedProviders([]);
    if (setProvider) setProvider(null);
  };

  if (!providerKeys.length) return null;

  const isAllSelected = !selectedProviders || selectedProviders.length === 0;

  return (
    <div
      className="py-4"
      style={{
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        background: "rgba(0,0,0,0.35)",
      }}
    >
      <Swiper
        modules={[FreeMode]}
        slidesPerView="auto"
        spaceBetween={6}
        freeMode={true}
        className="provider-swipe-selector !px-2"
      >
        {providerKeys.map((providerKey) => {
          const originalName = parseOriginalName(providerKey);
          const logo = ProviderLogo[originalName];
          const isSelected =
            selectedProviders && selectedProviders.includes(providerKey);

          return (
            <SwiperSlide key={providerKey} style={{ width: "auto" }}>
              <button
                onClick={() => handleToggle(providerKey)}
                style={
                  isSelected
                    ? {
                        background:
                          "linear-gradient(135deg, #02142c38 0%, #02142c1a 100%)",
                        boxShadow: "0 0 14px #02142c1a",
                      }
                    : {
                        background: "#02142c1a",
                      }
                }
                className={`relative flex items-center justify-center h-[64px] min-w-[108px] max-w-[132px] px-3 rounded-xl border transition-all duration-200 active:scale-95 overflow-hidden ${
                  isSelected
                    ? "border-secondary-50/70"
                    : "border-white/10 hover:border-white/22"
                }`}
              >
                {/* Seçili göstergesi - alt çizgi */}
                {isSelected && (
                  <span
                    className="absolute bottom-0 left-1/2 -translate-x-1/2 h-[2px] w-10 rounded-full"
                    style={{
                      background: "linear-gradient(90deg, #0057d1, #0057d1)",
                    }}
                  />
                )}
                {logo ? (
                  <img
                    src={logo}
                    alt={originalName}
                    className="max-h-[36px] max-w-[100px] object-contain"
                    style={
                      isSelected
                        ? { filter: "brightness(1.2)" }
                        : { filter: "brightness(0.82) saturate(0.75)" }
                    }
                  />
                ) : (
                  <span
                    className={`text-[10px] font-bold uppercase text-center leading-tight tracking-wide ${isSelected ? "text-[#f5d580]" : "text-white/50"}`}
                  >
                    {originalName.replace(/-/g, " ").replace(/_/g, " ")}
                  </span>
                )}
              </button>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { authentication, game } = state;
  const { loggedIn, permissions } = authentication;
  const { games } = game;
  return { games, permissions, loggedIn };
};

export default connect(mapStateToProps)(ProviderSwipeSelector);
